/**
 * Cover for a named approver (a regional stand-in, a named final approver)
 * can have an end date. Past it the naming confers nothing and the stage goes
 * back to whoever normally signs it - backend namedApprovalActive
 * (src/monthlyReport/reportAccess.mjs), which this mirrors so the page and the
 * server agree on who may act (the user, 2026-10-21).
 */

/** Is the report's naming still live? A naming with no end date always is. */
export const namedCoverActive = (report, now = new Date()) =>
  !report?.approverAccessEndsAt || new Date(report.approverAccessEndsAt) >= now;

/**
 * This reader was the regional stand-in and their cover has ended, while the
 * report still waits at the regional stage. Null otherwise; the end time when so.
 */
export const myRegionalCoverEnded = (report, user, now = new Date()) => {
  if (!report || !user || report.status !== 'auditor_approved' || report.approvalPath === 'skip_regional') return null;
  if (!report.regionalApproverId || String(report.regionalApproverId) !== String(user.id)) return null;
  return namedCoverActive(report, now) ? null : report.approverAccessEndsAt;
};

/** "21 Oct 2026, 13:00" in the reader's own timezone. */
export const coverEndText = (value) => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
};

const namedCover = { namedCoverActive, myRegionalCoverEnded, coverEndText };
export default namedCover;
